/** The look the auth step's controls share, so its two screens cannot drift. */
export const authFieldStyles = {
  background: "white",
  height: "48px",
  borderRadius: "10px",
  fontSize: "md",
} as const;

export const authSubmitStyles = {
  colorScheme: "seaGreen",
  height: "48px",
  borderRadius: "10px",
  fontSize: "md",
  width: "100%",
} as const;

/**
 * Scoped to the auth step via `sx` rather than the shared Checkbox theme, which
 * every checkbox in the app would inherit.
 */
export const authCheckboxStyles = {
  colorScheme: "seaGreen",
  alignItems: "flex-start",
  sx: {
    ".chakra-checkbox__control": {
      width: "20px",
      height: "20px",
      borderRadius: "5px",
      borderWidth: "1px",
      borderColor: "gray.400",
      background: "white",
      "&[data-checked]": {
        background: "seaGreen.500",
        borderColor: "seaGreen.500",
      },
    },
  },
} as const;
